import React from 'react';

import { Loading } from 'components/shared/Loading';

import styles from './SessionProvider.module.scss';

const SessionProvider = ({
  loading,
  children,
}: {
  loading: any;
  children: any;
}) => (loading ? <Loading className={styles.loading} /> : children);

export default React.memo(SessionProvider) as any;
